import React from "react";
import { Route, Routes } from "react-router-dom";

import EmailValidation from "@/components/screens/EmailValidation";
import { EMAIL_VALIDATION_MESSAGES } from "@/messages/emailValidation/email-validation.messages";

const EmailValidationPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<EmailValidation messages={EMAIL_VALIDATION_MESSAGES} />} />
      <Route path="/" element={<EmailValidation messages={EMAIL_VALIDATION_MESSAGES} />} />
    </Routes>
  );
};

export default EmailValidationPage;
